import React from 'react';
import './blogCard.css'; // Add custom styles here if needed
import blogimg from '../../assets/images/blog.png'
import { Link } from 'react-router-dom';
import { dateFormat } from '../../utils';

const BlogCard = ({data}) => {
  return (
    <div className="card mb-4 blog-card" style={{ borderRadius: '15px', backgroundColor: '#fff9f4' }}>
      <div className="card-body p-0">
        <Link to={`/blog-details/${ data.id || data._id }`}>
          <div className="blog-img-container">
            <img
              src={data.files?.at(0)?.Url || blogimg}
              alt="Temple"
              className=" main-img"
            
            />
          </div>
        </Link>
        <div className='p-3'>
          <div className="d-flex align-items-center">
            <p className="text-saffron mb-1 me-3 category-text">
              <span className="dot me-2 bg-saffron me-1" style={{ height: '8px', width: '8px', borderRadius: '50%', display: 'inline-block' }}></span>
              {dateFormat(data.createdAt)}
            </p>
            <p className='text-saffron mb-1 category-text'>
              <span className="dot me-2 bg-saffron me-1" style={{ height: '8px', width: '8px', borderRadius: '50%', display: 'inline-block' }}></span>
              {data.cityId?.name }
            </p>
          </div>
          <Link to={`/blog-details/${ data.id || data._id }`} className="card-title mb-2 fw-bold custom-text-color">{data?.title}</Link>
          <p className="card-text text-muted">
            { data.shortNote }
          </p>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
